import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Slot } from '../slot';
import { layoutRootRecipe } from './styles/layout-root.styles';
import type { LayoutRootPropsInterface } from './types/layout-root';

/**
 * Layout root is a specialized grid container used to quickly create a grid using common grid
 * configurations. Common configurations usually include definitions for gaps and column templates.
 *
 * @since 10.0.0
 */
export const LayoutRoot = forwardRef<HTMLDivElement, LayoutRootPropsInterface>(
  (props: LayoutRootPropsInterface, forwardedRef) => {
    const {
      asChild = false,
      children,
      className,
      css: cssProp,
      template = 'fluid12',
      ...rest
    } = props;
    const styles = css(layoutRootRecipe.raw({ template }), cssProp);
    const Component = asChild ? Slot : 'div';
    return (
      <Component
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Layout.Root"
        className={cx('c11n', 'c11n_layout__root', styles, className)}
        {...rest}
      >
        {children}
      </Component>
    );
  },
);

LayoutRoot.displayName = 'Layout.Root';
